import { auth } from "db/config";
import { signOut } from "firebase/auth";

/**
 * Cierra la sesión del usuario autenticado
 */
export const logout = async () => {
  return signOut(auth);
};
